
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[slug]/[articleId]",
      function () {
        return require("private-next-pages/news/[slug]/[articleId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[slug]/[articleId]"])
      });
    }
  